module.exports = __webpack_public_path__ + "img/flag-sr.291d0fb6.svg";